import { App } from './types/App'
import { App as VueApp } from 'vue'
import { Config } from './types/Config'
import { Settings } from './types/Settings'
import { Styles } from './types/Styles'
import { ServiceProvider } from './types/ServiceProvider'
import { getApp } from './getApp'
import { getConfig } from './getConfig'
import { getSettings } from './getSettings'
import { getStyles } from './getStyles'
import { getVueApp } from './getVueApp'

export interface Context {
  vueApp: VueApp
  app: App
  config: Config
  settings: Settings
  styles: Styles
}

export function setup (
  providers: ServiceProvider[],
) {
  const app = getApp()
  const config = getConfig()
  const settings = getSettings()
  const styles = getStyles()
  const vueApp = getVueApp()

  for (const provider of providers) {
    if (provider.setup) {
      provider.setup({
        vueApp,
        app,
        config,
        settings,
        styles,
      })
    }
  }
}
